<template>
  <div>
    <add-widget-dialog :bus="bus" @addWidget="addWidget" />
    <widget-form-dialog :bus="bus" @submit="dialogSubmitted" />
    <div>
      <div class="widgets">
        <div v-if="nonFieldErrors" class="non-field-error">
          {{ nonFieldErrors }}
        </div>
        <p class="widgets__list--empty" v-show="widgets.length === 0">
          Brak widgetów do wyświetlenia - dodaj nowy.
        </p>
        <ul class="widgets__list">
          <li
            class="widget"
            v-for="(widget, i) in widgets"
            :key="`${widget.id}  ${i}`"
            :class="{
              'widget--error': errors[i] && Object.keys(errors[i]).length > 0
            }"
            @click="editWidget(widget, errors[i])"
          >
            <div class="buttons">
              <el-button
                @click.stop="changeOrder(widgets, i, 1)"
                v-if="i !== widgets.length - 1"
                size="small"
                title="Przesuń w dół"
              >
                <i class="fa fa-arrow-down"></i>
              </el-button>
              <el-button
                @click.stop="changeOrder(widgets, i, -1)"
                :style="{ opacity: i !== 0 ? 1 : 0 }"
                size="small"
                title="Przesuń do góry"
              >
                <i class="fa fa-arrow-up"></i>
              </el-button>
              <el-button
                @click.stop="removeWidget(widget, i)"
                type="danger"
                size="small"
              >
                <i class="fa fa-remove"></i>
              </el-button>
            </div>
            <widget-preview :previewContent="previews[i]" :widget="widget" />
          </li>
        </ul>
        <el-button @click="openAddWidgetDialog" type="warning">
          <i class="fa fa-plus-circle" /> Dodaj nowy widget
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
import WidgetFormDialog from './WidgetFormDialog'
import AddWidgetDialog from './AddWidgetDialog'
import { Widget } from '@/api'
import Vue from 'vue'
import WidgetPreview from '@/components/widgets/WidgetPreview'

export default {
  props: {
    widgets: Array,
    errors: {
      type: [Array, String],
      default: () => []
    }
  },
  data() {
    return {
      bus: new Vue(),
      selectedWidget: {},
      previews: []
    }
  },
  beforeMount() {
    this.fetchData()
  },
  components: {
    WidgetFormDialog,
    AddWidgetDialog,
    WidgetPreview
  },
  computed: {
    nonFieldErrors() {
      const isString = typeof this.errors === 'string'
      return isString && this.errors
    }
  },
  methods: {
    fetchData() {
      this.$store.dispatch('fetchAvailableWidgets')
      this.$store.dispatch('fetchWidgetTypes')
    },
    editWidget(widget, errors) {
      this.bus.$emit('openWidgetFormDialog', widget, errors)
    },
    openAddWidgetDialog() {
      this.bus.$emit('openAddWidgetDialog')
    },
    addWidget(type) {
      this.widgets.push({
        resourcetype: type.resourcetype,
        margin_top: true,
        margin_bottom: false
      })
    },
    dialogSubmitted(oldForm, newForm) {
      const index = this.widgets.indexOf(newForm)
      if (index > -1) {
        this.$set(this.widgets, index, oldForm)
      }
      this.$forceUpdate()
    },
    removeWidget(widget, i) {
      this.removeItemFromFormset(this.widgets, widget)
      this.removeItemFromFormset(this.errors, this.errors[i])
    },
    updateWidgetsPreviews() {
      Widget.preview(this.widgets).then(res => {
        this.previews = res.data
      })
    }
  },
  watch: {
    widgets: {
      deep: true,
      handler() {
        this.updateWidgetsPreviews()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.non-field-error {
  color: red;
}

.widgets {
  width: 100%;

  &__list {
    padding: 0;
    position: relative;
    margin-bottom: 28px;
    list-style-type: none;

    &--empty {
      font-size: 13px;
    }
  }
}

.widget {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 15px 180px 15px 10px;
  border-top: 1px solid #f3f3f3;
  border-bottom: 1px solid #f3f3f3;
  cursor: pointer;
  position: relative;

  &:hover {
    background: #f3f3f3;
  }

  &--error {
    border-left: 3px solid red;
    color: red;
  }

  &__icon {
    max-width: 100%;
    max-height: 43px;
    display: inline-block;
    text-align: right;
  }
}

.buttons {
  position: absolute;
  top: 20px;
  right: 20px;
}
</style>
